import { render, staticRenderFns } from "./ReceiveOutsourceModal.vue?vue&type=template&id=38b040da&scoped=true"
import script from "./ReceiveOutsourceModal.vue?vue&type=script&lang=js"
export * from "./ReceiveOutsourceModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveOutsourceModal.vue?vue&type=style&index=0&id=38b040da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b040da",
  null
  
)

export default component.exports